import i18next from "../../../services/language/i18next";
import {Link} from "react-router-dom";
import {PATHS} from "../../../route-dictionary";
import {Trans} from "react-i18next";
import React from "react";

export const getTranslatedField = (fieldName) => {
  const translatedFields = {
    //check fields
    integration: i18next.t("form:label.integration", "Integration"),
    name: i18next.t("form:label.checkName", "Check name"),
    description: i18next.t("form:label.description", "Description"),
    type: i18next.t("form:label.checkType", "Check type"),
    url: i18next.t("form:label.url", "Url"),
    timeout: i18next.t("form:label.timeout", "Timeout"),
    down_timeout: i18next.t("form:label.downTimeout", "Down timeout"),
    balance_threshold: i18next.t("form:label.balance", "Balance threshold"),
    project: i18next.t("form:label.project", "Project"),
    is_telegram_auth_enabled: i18next.t("form:label.checkTelegramAuth.label", "Telegram authorization"),

    //rules fields
    from_time: i18next.t("form:label.fromTime", "From"),
    to_time: i18next.t("form:label.toTime", "To"),
    day_type: i18next.t("form:label.dayType", "Day type"),
    delay: i18next.t("form:label.delay", "Delay"),
    recur: i18next.t("form:label.recurment", "Recurment"),
    phones: i18next.t("form:label.phones", "Phones"),
    telegram_chats: i18next.t("form:label.chats", "Chats"),
    members_to_call: i18next.t("form:label.membersToCall", "Members to call"),
    is_enabled: i18next.t("form:label.ruleEnabled", "Enabled"),
  };
  return translatedFields[fieldName] || fieldName;
};

export const getTranslatedValues = (fieldName, value) => {
  const translatedValues = {
    day_type: {
      "i": i18next.t("rule.time.day.any", "Any"),
      "w": i18next.t("rule.time.day.weekday", "Working Days"),
      "h": i18next.t("rule.time.day.weekend", "Not Working Days")
    }
  };
  return translatedValues[fieldName]?.[value] || value;
};

const CHECK_HISTORY_CHANGES = {
  RULE: "rule",
  CHECK: "check",
  ACTIONS: {
    ADD: "+",
    CHANGE: "~",
    DELETE: "-"
  }
};

export function getTableColumnHeaders() {
  return [
    {
      key: "field",
      label: i18next.t("table:header.field", "Field"),
      _style: {width: "30%"},
    },
    {
      key: "old",
      label: i18next.t("table:header.old", "Original value"),
      _style: {width: "35%"},
    },
    {
      key: "new",
      label: i18next.t("table:header.new", "New value"),
      _style: {width: "35%"},
    }
  ];
}

export function getMemberLink(memberData) {
  const fullName = memberData?.first_name && `${memberData.first_name} ${memberData.last_name}`;

  return (
    <Link to={PATHS.MEMBERS.getDetailsIdPath(memberData?.id)}>
      {fullName || memberData?.email}
    </Link>
  );
}


export function getChangesText({member, type, id, action}, checkId) {
  const memberLink = getMemberLink(member);
  switch (type) {
    case CHECK_HISTORY_CHANGES.CHECK:
      const tableHeaderText = i18next.t("card.description.checkChanged", "made changes");
      return {memberLink, tableHeaderText};
    case CHECK_HISTORY_CHANGES.RULE:
      const ruleLink = PATHS.CHECKS.getChecksRuleDetailsPath({ruleId: id, checkId});
      if (action === CHECK_HISTORY_CHANGES.ACTIONS.ADD) {
        return {
          ruleCreatorText: memberLink,
          ruleCreationText: <Trans i18nKey="card.description.ruleCreated">
            <>created the <Link to={ruleLink}> rule </Link></>
          </Trans>
        };
      } else {
        return {
          memberLink,
          tableHeaderText: <Trans i18nKey="card.description.ruleChanged">
            <>made changes in <Link to={ruleLink}> rule </Link></>
          </Trans>
        };
      }
    default:
      return {};
  }
}